import { useState } from 'react';
import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { Row, Button, Column } from 'components/Blocks';
import { CardsIcon, UsersIcon, PlusIcon, TableIcon } from 'components/Icons';
import { ButtonGroup } from 'components/ButtonGroup';

import { TeamCards } from './TeamCards';
import { TeamsTable } from './TeamsTable';

import { appStorage } from 'utils/storage';

const viewKey = '__a_tv';

function Teams() {
  const { t } = useLang();

  const [view, setView] = useState(() => appStorage.session.get(viewKey) ?? 'cards');

  const teams = loaders.teams.list.use({
    defaultValue: [],
  });

  const changeView = (view: string) => {
    setView(view);
    appStorage.session.set(viewKey, view);
  };

  const View = view === 'cards' ? TeamCards : TeamsTable;

  return (
    <Column>
      <Row gap="2">
        <h4 className="mr-auto flex items-center gap-2">
          <UsersIcon size={40} />

          {t('teams')}
        </h4>

        <Button to="createTeam" variant="ghost" size="small">
          <PlusIcon />
          <span className="phone:hidden">{t('create-team')}</span>
        </Button>

        <ButtonGroup
          value={view}
          onChange={changeView}
          options={[
            { label: <CardsIcon />, value: 'cards' },
            { label: <TableIcon />, value: 'table' },
          ]}
        />
      </Row>

      <View teams={teams.data} loading={teams.errorOrLoading} />
    </Column>
  );
}

export default Teams;
